import ZlbConfirm from '@/components/ZlbConfirm';
import { 
  reqAssociatedList,
  reqUnassociatList,
  reqDetail,
  reqTobeAssociated,
  reqCancelAssociated,
} from '../services';

const responseErrorHandle = (res) => {
  const { success, message, statusText } = res || {};
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'acrossUnit',
  state: {
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    associatedList: [], // 已关联的机构列表
    unitDetail: {}, // 单位信息
    unassociatPagination: { 
      current: 1,
      pageSize: 10,
      total: 0,
    },
    unassociatList: [], // 待关联的机构列表

  },
  effects: {
    // 已关联的机构列表
    * getAssociatedList ({ payload }, { call, put }) {
      const res = yield call(reqAssociatedList, payload);
      responseErrorHandle(res);
      const { page = 1, size = 10, total = 0, data = [] } = res?.result || {};
      yield put({
        type: 'update',
        payload: {
          associatedList: data || [],
          pagination: {
            current: page,
            pageSize: size,
            total,
          },
        },
      });
      return res;
    },

    // 待关联的机构列表 
    * getUnassociatList ({ payload }, { call, put }) {
      const res = yield call(reqUnassociatList, payload);
      responseErrorHandle(res);
      const { page = 1, size = 10, total = 0, data = [] } = res?.result || {};
      yield put({
        type: 'update',
        payload: {
          unassociatList: data || [],
          unassociatPagination: {
            current: page,
            pageSize: size,
            total,
          },
        },
      });
      return res;
    },

    // 机构详情
    * getUnitDetail ({ payload }, { call, put }) {
      const res = yield call(reqDetail, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          unitDetail: res?.result || {},
        },
      });
      return res;
    },
    
    // 新增关联
    * tobeAssociated ({ payload }, { call }) {
      const res = yield call(reqTobeAssociated, payload);
      responseErrorHandle(res);
      return res;
    },

    // 取消关联
    * cancelAssociated ({ payload }, { call }) {
      const res = yield call(reqCancelAssociated, payload);
      responseErrorHandle(res);
      return res;
    },
    
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
